import { ImageTile } from 'ol';
import ImageWrapper from 'ol/Image';
import { ImageWMS, Tile, TileWMS } from 'ol/source';
import { Options } from 'ol/source/TileWMS';

export class GeopostSingleTileWMSSource extends ImageWMS {
    constructor(settings: Options, jwtToken: string, proxyUrl: string){
        super({
            ...settings,
            imageLoadFunction: (tile, url) => {
                let client = new XMLHttpRequest();
                url += '&host=' + settings.url;
                client.open('GET', url);
                client.responseType = 'arraybuffer';
                client.setRequestHeader('Authorization', 'Bearer ' + jwtToken);
                client.onload = () => {
                    const arrayBufferView = new Uint8Array(client.response);
                    const blob = new Blob([arrayBufferView], { type: 'image/png' });
                    const urlCreator = window.URL || window.webkitURL;
                    const imageUrl = urlCreator.createObjectURL(blob);
                    ((tile as ImageWrapper).getImage() as HTMLImageElement).src = imageUrl;
                };
                client.send();
            }
        });

        this.setUrl(proxyUrl + '/mapProxy?');
    }
}